import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/logo-color.png'


const _hoisted_1 = { class: "auth-layout" }
const _hoisted_2 = { class: "auth-layout_main" }
const _hoisted_3 = {
  key: 0,
  class: "auth-layout_footer"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AuthLayout',
  props: {
    showForgotPassword: { type: Boolean }
  },
  setup(__props: any) {


const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "auth-layout_brand" }, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: "Forth Logo",
        class: "auth-layout_brand-image"
      })
    ], -1)),
    _createElementVNode("main", _hoisted_2, [
      _createVNode(_component_router_view)
    ]),
    (__props.showForgotPassword)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/remind-password",
            class: "auth-layout_forgot-password-link"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode(" Forgot Your Password? ", -1)
            ]))]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})